export default [
  {
    path: '/taxa-media-depreciacao',
    component: () => import('@/views/Index'),
    children: [
      {
        name: 'Taxa Média de Depreciação Histórico',
        path: 'historico',
        component: () => import('@/views/taxaMediaDepreciacao/Historico.vue'),
        meta: {
          requiresAuth: true,
          breadcrumb: [{ name: 'Power Ups', path: '/powerups' }, { name: 'Taxa Média de Depreciação' }]
        }
      },
      {
        name: 'Taxa Média de Depreciação Adicionar',
        path: 'edit',
        component: () => import('@/views/taxaMediaDepreciacao/Edit.vue'),
        meta: {
          requiresAuth: true,
          breadcrumb: [
            { name: 'Power Ups', path: '/powerups' },
            { name: 'Taxa Média de Depreciação', path: '/taxa-media-depreciacao/historico' },
            { name: 'Adicionar' }
          ]
        }
      },
      {
        name: 'Taxa Média de Depreciação Editar',
        path: 'edit/:id',
        component: () => import('@/views/taxaMediaDepreciacao/Edit.vue'),
        meta: {
          requiresAuth: true,
          breadcrumb: [
            { name: 'Power Ups', path: '/powerups' },
            { name: 'Taxa Média de Depreciação', path: '/taxa-media-depreciacao/historico' },
            { name: 'Editar' }
          ]
        }
      }
    ]
  }
];
